import { Controller } from "react-hook-form";
import { SwitchField } from "./switch-field";

export const SwitchFormField: React.FC<any> = (props) => {
  const { name, defaultValue, control } = props;
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <SwitchField
          {...props}
          value={value}
          onChange={onChange}
          error={error}
        />
      )}
    />
  );
};
